module.exports = [
  {
    name: "Zack",
    age: "24",
    gender: "Male",
    occupation: "Entrepreneur",
    blurb: [
      "Just a chill guy."
    ],
    lookingFor: "someone who makes me laugh, has a nice smile, not judgmental",
    hobbies: "dance. Fortnite. Reddit. parties. anime. BTS.",
  },
  {
    name: "Mona",
    age: "22",
    gender: "Female",
    occupation: "Barista",
    blurb: [
      "so I wait for you like a lonely house",
      "till you will see me again and live in me.",
      "Till then my windows ache.",
    ],
    lookingFor: "someone who can share the same dream with me.",
    hobbies: "walking, drinking, writing",
  },
  // {
  //   name: "Eli",
  //   age: "25",
  //   gender: "Male",
  //   occupation: "Engineer",
  //   blurb: [
  //     "I hustle, I keep it lit, swipe right if you're into anime."
  //   ],
  //   lookingFor: "a beautiful soul, someone chill as f*** but also down to get lit.",
  //   hobbies: "gym. tattoos. startups. basketball.",
  // },
]
